export default {
  data() {
    return {
      ranges: {
        today: function () {
          let n = new Date();
          const today = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0))

          return {
            label: 'Сегодня',
            active: false,
            dateRange: {
              start: today,
              end: today
            }
          }
        },
        yesterday: function () {
          let n = new Date();
          const yesterday = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1, 0, 0))

          return {
            label: 'Вчера',
            active: false,
            dateRange: {
              start: yesterday,
              end: yesterday
            }
          }
        },
        thisMonth: function () {
          let n = new Date();
          let startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
          let endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth() + 1, 0));

          return {
            label: 'Текущий месяц',
            active: false,
            dateRange: {
              start: startMonth,
              end: endMonth
            }
          }
        },
        lastMonth: function () {
          let n = new Date();
          let startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth() - 1, 1));
          let endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));

          return {
            label: 'Предыдущий месяц',
            active: false,
            dateRange: {
              start: startMonth,
              end: endMonth
            }
          }

        },
        allTime: function () {
          let n = new Date();

          let start = new Date("2018-01-01");
          let startDate = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0))
          let todayDate = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0))

          return {
            label: 'Всё время',
            active: false,
            dateRange: {
              start: startDate,
              end: todayDate
            }
          }
        },
      },
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
        'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      shortDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
      range: {
        start: null,
        end: null
      },
      captions: {
        title: 'Выбрать даты',
        ok_button: 'Применить'
      },
      dateRange: 0,
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/datePickerMixin.js